import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { isDesktop } from '../helpers/device-utils';

@Injectable({
  providedIn: 'root',
})
export class MobileGuard {
  private router = inject(Router);

  constructor() {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const canGo = !isDesktop();

    if (!canGo) {
      this.router.navigate(['']);
    }

    return canGo;
  }
}
